/** @jsxImportSource @emotion/react */
import { Button, Select } from "antd";
import tw, { styled, css } from "twin.macro";
import { COLORS, MEDIA_BREAKPOINTS, TRANSITIONS } from "./styles";
import "antd/dist/antd.css";

// DISPLAY
export const LandingTitle = styled.h3`
	${tw`text-appTextDark font-semibold text-base md:text-4xl `};
	line-height: 3.063rem;
`;

export const CardBox = styled.span`
	${tw`hover:shadow flex flex-col justify-center cursor-pointer`}
	height: 150px;
	width: 150px;
	border-radius: 18px;
	padding: 12px;
	${({ bg }) => bg && `background: ${bg};`};
`;
export const ProductWrapper = styled.div`
	${tw`p-0 rounded-custom relative`}
	border-radius: 10px;
	background-color: ${COLORS.appGray10};
	${({ bg }) => bg && `background: url(${bg});`}
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const floatBtn = (props) => css`
	${tw`absolute font-bold bg-appPink flex items-center justify-center rounded-full border-none text-white h-12 w-12 hover:(shadow-lg cursor-pointer)`}
	bottom: 1.5rem;
	right: 1.5rem;
	font-size: 2rem;
	box-shadow: 0px 10px 35px rgba(241, 94, 95, 0.25);
`;

export const SelectedBtnStyle = styled.button`
	${({ selected }) =>
		selected
			? tw`h-16 w-full hover:(cursor-pointer ring-2 ring-appLightPink!) text-base bg-appPink rounded-2xl text-white border border-appPink font-bold focus:ring-2`
			: `${inputStyle};
                width: 100%;
				color: ${COLORS.appPinkSaturated};
                font-size: 1rem;
                height: 4rem;
            `}
`;

export const btnStyle = css`
	${tw`h-12 w-full active:(text-white) hover:(cursor-pointer text-white bg-appPinkSaturated ring-2 ring-appLightPink!) font-semibold text-base bg-appPink rounded-2xl text-white border border-none focus:(bg-appPink! ring-2 text-white! font-bold)`}
`;

export const ButtonLightPink = styled(Button)`
	${tw`bg-appLightPink text-appPink rounded-2xl font-semibold px-4 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)`}
`;

export const AppButton = styled(Button)`
	${btnStyle}
`;

export const active = (props) => css`
	${tw`bg-appPinkSaturated! text-white! text-xs font-medium shadow`}
	/* background: rgb(250, 115, 139, 0.2); */
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;
export const inactive = (props) => css`
	${tw`text-appTextFaded! text-xs font-medium shadow`}
	background: rgb(175, 178, 181, 0.2);
	font-family: Poppins;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 12px;
	/* identical to box height, or 100% */
	letter-spacing: 0.5px;
	/* Dark */
	color: #32323284;
`;

export const Wrapper = styled.div`
	${tw`p-4 md:p-6 h-full relative`}
`;

// export const active = (props) => css`
// 	${tw`shadow rounded-2xl min-w-min text-white bg-appPink inline-flex gap-2 items-center justify-center py-4 text-base hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`}
// 	font-family: Poppins;
// 	line-height: 12px;
// 	letter-spacing: 0.5px;
// `;
// export const inactive = (props) => css`
// 	${tw`text-appTextFaded! font-medium shadow  rounded-2xl min-w-min text-white bg-appGentleGray inline-flex gap-2 text-base items-center justify-center py-4 hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`}
// 	font-family: Poppins;
// 	line-height: 12px;
// 	letter-spacing: 0.5px;
// `;

export const hideScrollbar = (props) => css`
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
`;

export const inputStyle = (props) => css`
	${tw`text-appTextDark border-solid mb-4 px-2 py-0 md:(px-3 py-3) placeholder-appPlaceholder h-12 
    relative border border-transparent focus:outline-none! focus:ring-2! focus:ring-appLightPink!
    rounded-xl text-xs sm:text-sm md:text-lg shadow-sm!`}
	border: 1px solid #dedef0 !important;
	width: ${props.width || `100%`};
	display: flex;
	align-items: center;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	&:hover {
		border: 1px solid #ff5a62 !important;
	}
`;

export const FloatBtn = styled(Button)`
	${tw`font-bold bg-appPink rounded-full border-none text-white h-16 w-16`}
	display: none;
	position: absolute;
	bottom: 3.5rem;
	right: 3.5rem;
	font-size: 3rem;
	box-shadow: 0px 10px 35px rgba(241, 94, 95, 0.25);
	@media (max-width: 1217px) {
		${tw`flex items-center justify-center h-12 w-12`}
		bottom: 1.5rem;
		right: 1.5rem;
		font-size: 2rem;
	}
`;

export const AppSelect = styled(Select)`
	${tw`text-appTextDark border-solid mb-4 px-2 py-0 md:(px-3 py-3) placeholder-appPlaceholder h-12 
    relative border border-transparent focus:outline-none! focus:ring-2! focus:ring-appLightPink!
    rounded-xl text-xs sm:text-sm md:text-lg shadow-sm!`}
	border: 1px solid #dedef0 !important;
	width: ${({ width }) => (width ? width : `100%`)};
	display: flex;
	align-items: center;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	&:hover {
		border: 1px solid #ff5a62 !important;
	}
`;

export const selectStyle = (props) => css`
	.ant-select-selector {
		${tw`pl-10 border-none!`}
	}
	.ant-select-selection-item {
		${tw`h-8 w-full inline-flex items-center text-xs px-4 font-medium`}
		background: rgba(8,160,247, 0.2);
		border-radius: 200px;
		color: #1778b0;
	}
	width: ${props.width || `100%`};
`;

export const searchStyle = (props) => css`
	caret-color: red;
	.ant-input-affix-wrapper {
		border-radius: 40px !important;
		height: 40px;
		${tw`mr-0 md:mr-3!`}
	}

	.ant-input-search {
		/* border: 1px solid #f4f4f8; */
		box-sizing: border-box;
		width: 20vw;
		border-radius: 40px !important;
		font-size: 1rem;
	}
`;

export const label = (props) => css`
	${tw`text-appTextDark opacity-50 font-semibold text-lg`}
`;
export const formControl = (props) => css`
	${tw`pt-3 flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-2`}
`;

export const otpStyle = css`
	${tw`text-appTextDark border-solid mb-4 px-3 py-3 placeholder-appGentleGray h-16 w-16! mr-3! sm:px-1! sm:py-1! text-appTextDark 
    relative border border-transparent focus:outline-none! focus:ring-2! focus:ring-appPink!
    rounded-xl text-4xl! shadow! text-center flex flex-row items-center justify-center`}
	border: 1px solid #dedef0 !important;
	-webkit-appearance: none;
	&:hover {
		border: 1px solid #ff5a62 !important;
	}
	.ant-input-number-input {
		text-align: center !important;
	}
	.ant-input-number-handler-wrap {
		display: none !important;
	}
`;

// CONTAINERS, SIZES, MARGINS, PADDINGS
export const containerFluid = (bg) => {
	return css`
		width: 100%;
		height: auto;
		${bg ? "background: " + bg : ""}
	`;
};

export const pagePadding = () => {
	return css`
		// SIZE BOX
		box-sizing: border-box;

		// PADDING FOR DESKTOP
		@media (min-width: ${MEDIA_BREAKPOINTS.smallDesktop}px) {
			padding-left: 70px;
			padding-right: 70px;
		}

		// PADDING FOR TABLETS
		@media (min-width: ${MEDIA_BREAKPOINTS.largeMobile}px) and (max-width: ${MEDIA_BREAKPOINTS.smallDesktop}px) {
			padding-left: 40px;
			padding-right: 40px;
		}

		// PADDING FOR MOBILE
		@media (max-width: ${MEDIA_BREAKPOINTS.largeMobile}px) {
			padding-left: 20px;
			padding-right: 20px;
		}
	`;
};

export const transition = (type) => {
	switch (type) {
		case "primary":
			return css`
				transition: all ${TRANSITIONS.fast} ${TRANSITIONS.bounce};
			`;
		default:
			return css`
				transition: all 0.25s ease-in-out;
			`;
	}
};

// EFFECTS
export const textShadow = (depth) => {
	const SHADOW_COLOR_DARK_GREY = "rgba(63, 61, 86, 0.39)";
	return css`
		text-shadow: 0px 5px ${depth || 4}px ${SHADOW_COLOR_DARK_GREY};
	`;
};

export const GatewayButton = styled(Button)`
	border: none;
	display: flex;
	flex-direction: row;
	gap: 10px;
	align-items: center;
	width: 100%;

	&:hover {
		color: red;
	}
`;
